<template>
  <div>
    <div
      class="container"
      v-if="spinner"
      style="padding-bottom: 280px !important; padding-top: 280px !important"
    >
      <div class="col-lg-6 col-md-6 ml-auto mr-auto">
        <div id="loading-bg">
          <div class="loading-logo">
            <!-- <img
              src="favicon.ico"
              alt="Logo"
              style="
                max-width: 120px;
                margin-top: 200px;
                right: 20px;
                position: relative;
              "
            /> -->
          </div>
          <div class="loading">
            <div class="effect-1 effects"></div>
            <div class="effect-2 effects"></div>
            <div class="effect-3 effects"></div>
          </div>
        </div>
      </div>
    </div>
    <div
      class="container"
      v-if="!tokenSucess && !spinner && !registerResponse"
      style="padding-bottom: 90px !important; padding-top: 90px !important"
    >
      <div class="col-lg-6 col-md-6 ml-auto mr-auto">
        <form @submit.prevent="login">
          <card
            class="card-login card-white text-left"
            style="border-radius: 10"
          >
            <template slot="header">
              <img src="icons8-trash-200.png" class="card-img-email" alt="" />
            </template>

            <div>
              <h1 class="card-title text-center">Link de Registro Caducado</h1>
              <!-- <p>El link de registro ha expirado.</p> -->
            </div>

            <div slot="footer"></div>
          </card>
        </form>
      </div>
    </div>
    <div class="container" v-if="tokenSucess && !spinner && !registerResponse">
      <div class="row">
        <div class="col-md-5 ml-auto backgroud-image">
          <!-- <div class="info-area info-horizontal mt-5" >
          
          <div class="icon icon-warning">
            <i class="tim-icons icon-wifi"></i>
          </div>
          <div class="description">
            <h3 class="info-title">Marketing</h3>
            <p class="description">
              We've created the marketing campaign of the website. It was a very
              interesting collaboration.
            </p>
          </div>
        </div>
        <div class="info-area info-horizontal">
          <div class="icon icon-primary">
            <i class="tim-icons icon-triangle-right-17"></i>
          </div>
          <div class="description">
            <h3 class="info-title">Fully Coded in HTML5</h3>
            <p class="description">
              We've developed the website with HTML5 and CSS3. The client has
              access to the code using GitHub.
            </p>
          </div>
        </div>
        <div class="info-area info-horizontal">
          <div class="icon icon-info">
            <i class="tim-icons icon-trophy"></i>
          </div>
          <div class="description">
            <h3 class="info-title">Built Audience</h3>
            <p class="description">
              There is also a Fully Customizable CMS Admin Dashboard for this
              product.
            </p>
          </div> 
        </div>-->
        </div>

        <div class="col-md-7 mr-auto">
          <form>
            <card class="card-register card-white text-left">
              <h3 style="text-align: center">
                Registro

                <img
                  :src="countrySelected.flagUrl"
                  alt="Country Flag"
                  style="width: 30px;"
                />
              </h3>
              <div class="row">
                <div class="col-md-6">
                  <div
                    class="form-group has-label"
                    :class="{
                      'has-danger': $v.firstName.$error,
                    }"
                  >
                    <slot name="label">
                      <label> Nombre </label>
                    </slot>
                    <div class="mb-0">
                      <slot>
                        <input
                          class="form-control"
                          v-model="firstName"
                          type="text"
                          placeholder="Nombre"
                          style="text-align: left !important"
                        />
                      </slot>
                    </div>
                    <slot name="error" v-if="$v.firstName.$error">
                      <label class="error">Este campo es requerido</label>
                    </slot>
                  </div>
                </div>
                <div class="col-md-6">
                  <div
                    class="form-group has-label"
                    :class="{
                      'has-danger': $v.lastName.$error,
                    }"
                  >
                    <slot name="label">
                      <label> Apellido </label>
                    </slot>
                    <div class="mb-0">
                      <slot>
                        <input
                          class="form-control"
                          v-model="lastName"
                          type="text"
                          placeholder="Apellido"
                          style="text-align: left !important"
                        />
                      </slot>
                    </div>
                    <slot name="error" v-if="$v.lastName.$error">
                      <label class="error">Este campo es requerido</label>
                    </slot>
                  </div>
                </div>
                <div class="col-md-6">
                  <div
                    class="form-group has-label"
                    :class="{
                      'has-danger': $v.phone.$error,
                    }"
                  >
                    <slot name="label">
                      <label> Numero de Telefono </label>
                    </slot>
                    <div class="mb-0">
                      <slot>
                        <input
                          class="form-control"
                          v-model="phone"
                          type="text"
                          placeholder="Numero de Telefono"
                          style="text-align: left !important"
                        />
                      </slot>
                    </div>
                    <slot name="error" v-if="$v.phone.$error">
                      <label class="error">Este campo es requerido</label>
                    </slot>
                  </div>
                </div>
                <div class="col-md-6">
                  <div
                    class="form-group has-label"
                    :class="{
                      'has-danger': $v.birthdayDate.$error,
                    }"
                  >
                    <slot name="label">
                      <label> Fecha de Nacimiento </label>
                    </slot>
                    <div class="mb-0">
                      <slot>
                        <el-date-picker
                          type="date"
                          placeholder="Fecha de Nacimiento"
                          v-model="birthdayDate"
                          :class="{
                            'has-danger': $v.birthdayDate.$error,
                          }"
                          format="dd/MM/yyyy"
                          style="text-align: left !important"
                        >
                        </el-date-picker>
                      </slot>
                    </div>
                    <slot name="error" v-if="$v.birthdayDate.$error">
                      <label class="error">Este campo es requerido</label>
                    </slot>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group has-label">
                    <slot name="label">
                      <label> Sexo </label>
                    </slot>
                    <div class="mb-0">
                      <slot>
                        <!-- <input
                        class="form-control"
                        aria-describedby="addon-right addon-left"
                        v-model="gender"
                        type="text"
                        placeholder="Genero"
                      /> -->
                        <el-select
                          class="select-primary"
                          size="large"
                          placeholder="Single Select"
                          v-model="gender"
                          :class="{
                            'has-error': $v.gender.$error,
                          }"
                        >
                          <el-option
                            v-for="option in genders"
                            class="select-primary"
                            :value="option.id"
                            :label="option.label"
                            :key="option.id"
                          >
                          </el-option>
                        </el-select>
                      </slot>
                    </div>
                    <slot name="error" v-if="$v.gender.$error">
                      <label class="error" style="color: red"
                        >Este campo es requerido</label
                      >
                    </slot>
                  </div>
                </div>
                <div class="col-md-12">
                  <hr />
                  <div
                    class="form-group has-label"
                    :class="{
                      'has-danger': $v.email.$error,
                    }"
                  >
                    <slot name="label">
                      <label> Correo Electronico </label>
                    </slot>
                    <div class="mb-0">
                      <slot>
                        <input
                          class="form-control"
                          v-model="email"
                          type="email"
                          placeholder="Correo Electronico"
                          disabled
                          style="text-align: left !important"
                        />
                      </slot>
                    </div>
                    <slot name="error" v-if="$v.email.$error">
                      <label class="error">Este campo es requerido</label>
                    </slot>
                  </div>
                </div>
                <div class="col-md-6">
                  <div
                    class="form-group has-label"
                    :class="{
                      'has-danger': $v.password.$error,
                    }"
                  >
                    <slot name="label">
                      <label> Contraseña </label>
                    </slot>
                    <div class="mb-0">
                      <slot>
                        <input
                          class="form-control"
                          v-model="password"
                          type="password"
                          placeholder="Contraseña"
                          style="text-align: left !important"
                        />
                      </slot>
                    </div>
                    <slot
                      name="error"
                      v-if="!$v.password.required && $v.password.$error"
                    >
                      <label class="error">Este campo es requerido</label>
                    </slot>
                    <slot
                      name="error"
                      v-else-if="
                        !$v.password.goodPassword && $v.password.$error
                      "
                    >
                      <label class="error"
                        >Debe tener al menos 8 caracteres y contener un carácter
                        en minúscula, un carácter en mayúscula y un
                        número.</label
                      >
                    </slot>
                  </div>
                </div>
                <div class="col-md-6">
                  <div
                    class="form-group has-label"
                    :class="{
                      'has-danger': !$v.confirmPassword.sameAsPassword,
                    }"
                  >
                    <slot name="label">
                      <label> Confirmar Contraseña </label>
                    </slot>
                    <div class="mb-0">
                      <slot>
                        <input
                          class="form-control"
                          v-model="confirmPassword"
                          type="password"
                          placeholder="Confirmar Contraseña"
                          style="text-align: left !important"
                        />
                      </slot>
                    </div>
                    <slot
                      name="error"
                      v-if="!$v.confirmPassword.sameAsPassword"
                    >
                      <label class="error"
                        >Las contraseñas deben ser idénticas.</label
                      >
                    </slot>
                  </div>
                </div>
              </div>

              <!-- <base-input
              v-validate="'required'"
              v-model="model.fullName"
              name="Full Name"
              placeholder="Full Name"
              addon-left-icon="tim-icons icon-single-02"
            >
            </base-input>

            <base-input
              v-validate="'required|email'"
              v-model="model.email"
              name="email"
              placeholder="Email"
              addon-left-icon="tim-icons icon-email-85"
            >
            </base-input>

            <base-input
              v-validate="'required|min:5'"
              v-model="model.password"
              name="password"
              type="password"
              placeholder="Password"
              addon-left-icon="tim-icons icon-lock-circle"
            >
            </base-input> -->

              <!-- <base-checkbox class="text-left">
              Acepto los
              <a href="#something">términos y condiciones.</a>.
            </base-checkbox> -->

              <base-button
                slot="footer"
                type="primary"
                block
                size="lg"
                @click="register"
                :loading="registerLoading"
              >
                Registrar
              </base-button>
            </card>
          </form>
        </div>
      </div>
    </div>

    <div class="container" v-if="tokenSucess && !spinner && registerResponse">
      <div class="row">
        <div class="col-md-5 ml-auto backgroud-image"></div>

        <div class="col-md-7 mr-auto">
          <form>
            <card
              class="card-register card-white text-left"
              style="padding: 217px 0px"
            >
              <h2 style="text-align: center">Bienvenido a Impulso App</h2>
              <h5 style="text-align: center">
                Su cuenta se ha creado correctamente. Ahora puede iniciar sesion
                con su correo electronico y contraseña.
              </h5>
              <div class="row">
                <!-- <div class="col-md-6">
                  <div
                    class="form-group has-label"
                    :class="{
                      'has-danger': $v.firstName.$error,
                    }"
                  >
                    <slot name="label">
                      <label> Nombre </label>
                    </slot>
                    <div class="mb-0">
                      <slot>
                        <input
                          class="form-control"
                          v-model="firstName"
                          type="text"
                          placeholder="Nombre"
                          disabled
                          style="text-align: left !important"
                        />
                      </slot>
                    </div>
                    <slot name="error" v-if="$v.firstName.$error">
                      <label class="error">Este campo es requerido</label>
                    </slot>
                  </div>
                </div> -->
              </div>
            </card>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { Card } from "@/components/index";
import { DatePicker, Select } from "element-ui";
import { required, sameAs } from "vuelidate/lib/validators";
import moment from "moment";
import axios from "axios";
import { availableCountries } from "../../constants/available-countries.constants";

export default {
  components: {
    [DatePicker.name]: DatePicker,
    [Select.name]: Select,
    Card,
  },
  data() {
    return {
      userId: "",
      userMemberId: "",
      firstName: "",
      lastName: "",
      phone: "",
      birthdayDate: "",
      gender: "",
      email: "",
      password: "",
      confirmPassword: "",

      genders: [
        {
          id: "1901571a-97ea-4e22-b59a-0e6a41eba138",
          value: "Masculino",
          label: "Masculino",
        },
        {
          id: "0daa4bf4-12e5-4b33-8ac1-39ec809dadd6",
          value: "Femenino",
          label: "Mujer",
        },
        {
          id: "669027ae-de61-4cc6-acb3-c02b08d0d783",
          value: "No Especificado",
          label: "No Especificado",
        },
        {
          id: "e1077651-5b9a-497f-916e-00be06fb0731",
          value: "Desconocido",
          label: "Desconocido",
        },
      ],

      tokenSucess: false,
      spinner: true,

      registerLoading: false,
      registerResponse: false,

      countrySelected: {
        flagUrl:
          "https://firebasestorage.googleapis.com/v0/b/impulso-app-3bbf9.appspot.com/o/countries%2Fgt.png?alt=media&token=44693915-b22f-4386-8ae1-023bda2bc023",
        apiBaseUrl: "https://api.impulsofitness.com",
      },
    };
  },
  computed: {
    countryAlphaCode() {
      return this.$route.query.countryAlphaCode || "";
    },
  },
  validations: {
    firstName: {
      required,
    },
    lastName: {
      required,
    },
    phone: {
      required,
    },
    birthdayDate: {
      required,
    },
    gender: {
      required,
    },
    email: {
      required,
    },
    password: {
      required,
      goodPassword: (password) => {
        //a custom validator!
        return (
          password.length >= 8 &&
          /[a-z]/.test(password) &&
          /[A-Z]/.test(password) &&
          /[0-9]/.test(password)
        );
      },
    },
    confirmPassword: {
      sameAsPassword: sameAs("password"),
    },
  },
  methods: {
    register() {
      let instance = this;
      this.$v.$touch();
      //console.log(this.$v);
      if (!this.$v.$error) {
        this.registerLoading = true;
        let token = this.$route.query.token;
        let data = {
          userId: this.userId,
          userEmail: this.email,
          userPassword: this.password,
          userName: this.firstName,
          userLastName: this.lastName,
          userDOB: moment(this.birthdayDate).format("YYYY-MM-DD"),
          userMobile: this.phone,
          userSexId: this.gender,
        };
        axios
          .post(
            `${this.countrySelected.apiBaseUrl}/api/v1/admin-panel-user`,
            data,
            {
              params: {
                token: token,
              },
            }
          )
          .then(() => {
            instance.registerResponse = true;
            instance.registerLoading = false;
          })
          .catch(() => {
            this.$router.go(this.$router.currentRoute);
          });
        // this.registerLoading = true;
        // setTimeout(function () {
        //   instance.registerResponse = true;
        //   instance.registerLoading = true;
        // }, 2000);
      }
    },
  },
  async mounted() {
    this.spinner = true;

    try {
      const token = this.$route.query.token;

      // First request: get available countries
      const countriesAvailableRes = await axios.get(
        `${process.env.VUE_APP_GLOBAL_API_URL}/api/v1/countries`
      );

      if (!Array.isArray(countriesAvailableRes.data)) {
        throw new Error("No se pudo obtener la lista de países.");
      }

      const countrySelectedByAlphaCode = countriesAvailableRes.data.find(
        (country) => country.countryCode === this.countryAlphaCode
      );

      if (countrySelectedByAlphaCode) {
        this.countrySelected = countrySelectedByAlphaCode;
      }

      // Second request: get preregister user data
      const preregisterRes = await axios.get(
        `${this.countrySelected.apiBaseUrl}/api/v1/admin-panel-user/preregister`,
        {
          params: { token },
        }
      );

      if (!preregisterRes.data) {
        throw new Error(
          "No se pudo obtener los datos de preregistro del usuario."
        );
      }

      const data = preregisterRes.data;
      this.userId = data.userId;
      this.firstName = data.userName;
      this.lastName = data.userLastName;
      this.email = data.userEmail;
      this.tokenSucess = true;
    } catch {
      this.tokenSucess = false;
    } finally {
      this.spinner = false;
    }
  },
};
</script>
<style lang="scss" scoped>
.backgroud-image {
  background-image: url("../../assets/img/Imagen_FormularioRegistro.jpg");
  background-size: cover;
}

@media screen and (max-width: 640px) {
  .backgroud-image {
    background-image: url("../../assets/img/User_Back.jpg");
    background-size: cover;
    height: 100px;
    margin-left: 15px !important;
    margin-right: 15px !important;
  }
}
</style>
